import { useQuery } from '@tanstack/react-query';

import getClouderStatus from './getClouderStatus';

export default function useGetClouderStatus({ enabled = true } = {}) {
  return useQuery({
    queryKey: ['getClouderStatus'],
    queryFn: getClouderStatus,
    enabled,
  });
}
